import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import classNames from 'classnames';
import _ from 'lodash';
import Moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';
import 'react-widgets/lib/less/react-widgets.less';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import InputField from '../Common/inputField';
import DatePicker from '../Common/datePicker';
import { Grid, Row, Col, Panel, Button, Table, Input, Textarea } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'

momentLocalizer(Moment);



class InventoryConvertForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            orderNum: 0,

            inventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            },

            targetInventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            },

            convertedInventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        const { currentInventoryConvert } = this.props;
        if(currentInventoryConvert) {
          this.props.fetchInventoryConvertDetail(currentInventoryConvert.WarehouseConvert_id)
            .then(() => {
              this.props.fetchInventories();
            });
        }
        else {
          this.props.fetchInventories();
        }
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventories are ready, reset state.

    componentWillReceiveProps(nextProps) {
      if(nextProps.currentInventoryConvertDetail && nextProps.currentInventoryConvertDetail != this.props.currentInventoryConvertDetail){
        let orderNum = 0;
        let warehouse_Convert_Line = nextProps.currentInventoryConvertDetail.Warehouse_Convert_Line;
        warehouse_Convert_Line.map(convert => {
          orderNum = Math.max(orderNum, convert.Pairid);
        });
        orderNum = orderNum+1;
        const convertedInventories = {...this.state.convertedInventories, rows: nextProps.currentInventoryConvertDetail.Warehouse_Convert_Line };
        this.setState({ convertedInventories, orderNum: orderNum });
      }
        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
            let newInventories = [];
            newInventories = nextProps.inventories;
            const inventories = {...this.state.inventories, rows: nextProps.inventories }
            const targetInventories = {...this.state.targetInventories, rows: nextProps.inventories }
            this.setState({
                inventories,
                targetInventories
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    setInventoryToConvert(e) {
        e.preventDefault();
        const { inventories, targetInventories, convertedInventories, orderNum } = this.state;
        const inventoryToLocate = { ...inventories.selectedRows[0],
            Pairid: orderNum,
            Quantity: "-" + this.props.quantityValue
        };

        const inventoryConverted = { ...targetInventories.selectedRows[0],
            Pairid: orderNum,
            Quantity: "+" + this.props.convertedQuantityValue
        }

        let newConvertedInventoriesRows = [ ...convertedInventories.rows ];
        let newInventoriesRows = [ ...inventories.rows ];
        let newTargetInventoriesRows = [ ...targetInventories.rows ];

        newConvertedInventoriesRows.push(inventoryToLocate, inventoryConverted);

        // const index = _.findIndex(newInventoriesRows, { 'id': inventories.selectedRows[0].id });
        // if (index > -1) {
        //     newInventoriesRows.splice(index, 1);
        // }
        //
        // const targetIndex = _.findIndex(newTargetInventoriesRows, { 'id': targetInventories.selectedRows[0].id });
        // if (targetIndex > -1) {
        //     newTargetInventoriesRows.splice(targetIndex, 1);
        // }

        let newConvertedInventories = { ...convertedInventories, rows: newConvertedInventoriesRows };
        let newInventories = { ...inventories, rows: newInventoriesRows };
        let newTargetInventories = { ...targetInventories, rows: newTargetInventoriesRows };

        // newInventories.selectedRows = [];
        // newTargetInventories.selectedRows = [];

        this.setState({
            convertedInventories: newConvertedInventories,
            inventories: newInventories,
            targetInventories: newTargetInventories,
            orderNum: orderNum + 1
        })
    }

    cancelInventoryConvert(e) {
        e.preventDefault();
        const { inventories, targetInventories, convertedInventories } = this.state;
        const OrderID = convertedInventories.selectedRows[0].Pairid;

        let newConvertedInventoriesRows = [ ...convertedInventories.rows ];
        // let newInventoriesRows = [ ...inventories.rows ];
        // let newTargetInventoriesRows = [ ...targetInventories.rows ];

        let index = _.findIndex(newConvertedInventoriesRows, { 'Pairid': OrderID });
        if (index > -1 && parseInt(newConvertedInventoriesRows[index].Quantity) > 0 ) {
            // newTargetInventoriesRows.push({...newConvertedInventoriesRows[index]})
            newConvertedInventoriesRows.splice(index, 1);
            index = _.findIndex(newConvertedInventoriesRows, { 'Pairid': OrderID });
            // newInventoriesRows.push({...newConvertedInventoriesRows[index]})
            newConvertedInventoriesRows.splice(index, 1);
        } else if (index > -1) {
            // newInventoriesRows.push({...newConvertedInventoriesRows[index]})
            newConvertedInventoriesRows.splice(index, 1);
            index = _.findIndex(newConvertedInventoriesRows, { 'Pairid': OrderID });
            // newTargetInventoriesRows.push({...newConvertedInventoriesRows[index]})
            newConvertedInventoriesRows.splice(index, 1);
        }

        let newConvertedInventories = { ...convertedInventories, rows: newConvertedInventoriesRows };
        // let newInventories = { ...inventories, rows: newInventoriesRows };
        // let newTargetInventories = { ...targetInventories, rows: newTargetInventoriesRows };

        newConvertedInventories.selectedRows = [];

        this.setState({
            convertedInventories: newConvertedInventories
        })
    }

    createConvert(e) {
      e.preventDefault();
      if(this.props.currentInventoryConvertDetail) {
        if(!this.checkPermission("change_warehouse_convert"))
          this.props.editInventoryConvert(this.props.currentInventoryConvertDetail.WarehouseConvert_id, 1, this.props.postingDate, this.props.note, this.props.processingFee, Data.Selectors.getRows(this.state.convertedInventories));
        else
          alert("You have no permission!");
      }
      else
        this.props.createInventoryConvert(1, this.props.postingDate, this.props.note, this.props.processingFee, Data.Selectors.getRows(this.state.convertedInventories));
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.inventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var inventories = {...this.state.inventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ inventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.inventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const inventories = {...this.state.inventories, filters: newFilters }
                this.setState({ inventories });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const inventories = {...this.state.inventories, selectedRows: rows }
                this.setState({ inventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                },
                {
                    key: 'ProductDescription',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true
                },
                {
                    key: 'Batch_PONum',
                    name: <Translate value="batch_num" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryConvertForm-dataGrid1">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTargetTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.targetInventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var targetInventories = {...this.state.targetInventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ targetInventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.targetInventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const targetInventories = {...this.state.targetInventories, filters: newFilters }
                this.setState({ targetInventories });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const targetInventories = {...this.state.targetInventories, selectedRows: rows }
                this.setState({ targetInventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                },
                {
                    key: 'ProductDescription',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true
                },
                {
                    key: 'Batch_PONum',
                    name: <Translate value="batch_num" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryConvertForm-dataGrid2">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderConvertedTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.convertedInventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var convertedInventories = {...this.state.convertedInventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ convertedInventories: convertedInventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.convertedInventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const convertedInventories = {...this.state.convertedInventories, filters: newFilters }
                this.setState({ convertedInventories: convertedInventories });
            }

            // Handle the Dragable cell function

            const handleCellDrag = e => {
                let { convertedInventories } = this.state
                let rows = convertedInventories.rows.slice(0);
                for (let i = e.fromRow; i <= e.toRow; i++) {
                    let rowToUpdate = rows[i];
                    rowToUpdate[e.cellKey] = e.value;
                }
                const newConvertedInventories = {...convertedInventories, rows: rows }
                this.setState({
                    convertedInventories: newConvertedInventories
                });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let { convertedInventories } = this.state
                let rows = getRows();//convertedInventories.rows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                const newConvertedInventories = {...convertedInventories, rows: rows }
                this.setState({
                    convertedInventories: newConvertedInventories,
                });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const convertedInventories = {...this.state.convertedInventories, selectedRows: rows };
                this.setState({ convertedInventories: convertedInventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                },
                {
                    key: 'Quantity',
                    name: <Translate value="convert_quantity" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                    editable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryConvertForm-dataGrid3">
                    <ReactDataGrid
                        rowKey='Pairid'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onCellsDragged={handleCellDrag}
                        enableCellSelect={true}
                        onRowUpdated={handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const inventoryConvertWarehouseLoc = (<Translate value="inventory_convert_warehouse_location" />);
        const inventoryConvertSheetWarehouseloc = (<Translate value="inventory_convert_sheet_warehouse_location" />);
        const generalProductConvert = (<Translate value="general_product_convert" />);
        const { inventories, targetInventories, convertedInventories } = this.state;
        const { invalid } = this.props;
        return (
            <ContentWrapper>
                <div className="content-heading"><Translate value="inventory_convert" /></div>
                <Row><Col sm={ 12 }>
                    <Link to="/inventories/convert"  className="btn btn-green buttonStyle" ><em className="fa fa-mail-reply"/></Link>
                    <div className="pull-right">
                        <button
                          className="btn btn-primary buttonStyle"
                          onClick={(e) => this.createConvert(e) }>
                          <em className="fa fa-save marginRightStyle"/><Translate value="save" /></button>
                    </div>
                </Col></Row>
              <Row className="marginTopStyle">
                    <Col sm={ 7 }>
                        <Panel header={inventoryConvertWarehouseLoc}>
                            <Row>
                              <h4><Translate value="current_inventory" /></h4>
                              <hr/>
                                <Col sm={ 8 }>
                                    <p><Translate value="msg_select_an_inventory_to_convert" /></p>
                                    {this.renderTable() }
                                </Col>
                                <Col sm={ 4 }>
                                  <p><Translate value="details_and_convert" /></p>
                                    <Row>
                                        <Col sm={6}><label><Translate value="product_num" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductNum : "Please select an inventory"}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="product_name" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductName : "Please select an inventory"}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="package_type" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductUnitOfMeasure : "Please select an inventory"}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="batch_no_po_no" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : "Please select an inventory"}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="current_zone" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ZoneName : "Please select an inventory"}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="current_bin" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].BinName : "Please select an inventory"}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="current_quantity" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].BinAmount : "Please select an inventory"}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={ 6 }><label><Translate value="convert_quantity" /></label></Col>
                                        <Col sm={ 6 }>
                                          <Field component={InputField} name="Quantity"></Field>
                                        </Col>
                                    </Row>
                                    <Row><Col sm={ 12 }>
                                        {inventories.selectedRows[0] &&
                                            parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) &&
                                            <p className="parsley-error-message"><Translate value="msg_convert_qty_cannot_exceed_current_qty" /></p>}
                                    </Col></Row>
                                </Col>
                            </Row>
                            <Row>
                              <h4><Translate value="current_target_inventory" /></h4>
                              <hr/>
                              <Col sm={ 8 }>
                                  <p><Translate value="msg_select_an_inventory_as_target" /></p>
                                  {this.renderTargetTable() }
                              </Col>
                              <Col sm={ 4 }>
                                <p><Translate value="details_&_convert"/></p>
                                  <Row>
                                      <Col sm={6}><label><Translate value="product_num" /></label></Col>
                                      <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductNum : "Please select an inventory"}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="product_name" /></label></Col>
                                      <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductName : "Please select an inventory"}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="package_type" /></label></Col>
                                      <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductUnitOfMeasure : "Please select an inventory"}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="batch_no_po_no" /></label></Col>
                                      <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].Batch_PONum : "Please select an inventory"}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="current_zone" /></label></Col>
                                      <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ZoneName : "Please select an inventory"}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="current_bin" /></label></Col>
                                      <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].BinName : "Please select an inventory"}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="current_quantity" /></label></Col>
                                      <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].BinAmount : "Please select an inventory"}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={ 6 }><label><Translate value="convert_target_quantity" /></label></Col>
                                      <Col sm={ 6 }>
                                        <Field component={InputField} name="ConvertedQuantity"></Field>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col sm={ 6 }><label><Translate value="weight" /></label></Col>
                                      <Col sm={ 6 }>
                                        <Field component={InputField} name="Weight"></Field>
                                      </Col>
                                  </Row>
                              </Col>
                            </Row>
                            <Row><Col sm={ 12 }>
                                <button
                                    className="btn btn-primary pull-right marginTopStyle"
                                    onClick={(e) => this.setInventoryToConvert(e) }
                                    disabled={ !inventories.selectedRows[0] || !targetInventories.selectedRows[0] || invalid
                                        || parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus)
                                    }><Translate value="submit" /></button>
                            </Col></Row>
                        </Panel>
                      </Col>
                      <Col sm={ 5 }>
                        <Panel header={inventoryConvertSheetWarehouseloc}>
                            <h4><Translate value="inventory_convert_sheet" /></h4>
                            <hr/>
                            <p><Translate value="list_of_inventory_convert_lines" /></p>
                            {this.renderConvertedTable() }
                            <Row><Col sm={ 12 }>
                                <button
                                    className="btn btn-warning pull-right marginTopStyle"
                                    onClick={(e) => this.cancelInventoryConvert(e) }
                                    disabled={ !convertedInventories.selectedRows[0]}><Translate value="cancel" /></button>
                            </Col></Row>
                        </Panel>
                        <Panel header={generalProductConvert}>
                            <h4><Translate value="general" /></h4>
                            <hr/>
                            <Row>
                                <Col sm={ 7 }>
                                    <Col sm={ 6 }><Translate value="convert_date" />: </Col>
                                    <Col sm={ 6 } className="marginBottomStyle">
                                        <Field component={DatePicker} name="PostingDate"></Field>
                                    </Col>
                                    <Col sm={ 6 }><Translate value="processing_fee" />: </Col>
                                    <Col sm={ 6 }>
                                        <Field component={InputField} name="ProcessingFee"></Field>
                                    </Col>
                                    <Col sm={ 3 }><Translate value="note" />: </Col>
                                    <Col sm={ 9 }>
                                        <Field name="Note" component="Textarea" className="form-control" style={{ minHeight: '100px' }}/>
                                    </Col>
                                </Col>
                            </Row>
                        </Panel>
                    </Col>
                </Row>
                <br/>
            </ContentWrapper >
        );
    }
}



export default InventoryConvertForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryConvertForm.jsx